import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bordered-card bordered-card_secondary" }
const _hoisted_2 = { class: "fw-bold mb-5" }
const _hoisted_3 = { class: "d-flex flex-column w-100 gap-10" }
const _hoisted_4 = { class: "d-flex gap-2 justify-content-between align-items-center w-100" }
const _hoisted_5 = { class: "fw-light fs-sm" }
const _hoisted_6 = { class: "fw-bold sm-fs-xs text-end" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "divider mt-0 mb-0" }, null, -1)
const _hoisted_8 = { class: "d-flex justify-content-between gap-2 align-items-start w-100" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "fw-light fs-sm" }, "Email:", -1)
const _hoisted_10 = { class: "fw-bold sm-fs-xs" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "divider mt-0 mb-0" }, null, -1)
const _hoisted_12 = { class: "d-flex justify-content-between align-items-center gap-2 align-items-center w-100" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "fw-light fs-sm" }, "Contact Name:", -1)
const _hoisted_14 = { class: "fw-bold sm-fs-xs" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "divider mt-0 mb-0" }, null, -1)
const _hoisted_16 = { class: "d-flex justify-content-between gap-2 align-items-start w-100" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "fw-light fs-sm" }, "Contact Phone:", -1)
const _hoisted_18 = { class: "fw-bold sm-fs-xs d-flex flex-column gap-2 text-end" }
const _hoisted_19 = {
  key: 0,
  class: "divider mt-0 mb-0"
}
const _hoisted_20 = {
  key: 1,
  class: "d-flex justify-content-between align-items-center gap-2 w-100"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "fw-light fs-sm" }, "PIN Expiration:", -1)
const _hoisted_22 = { class: "fw-bold sm-fs-xs" }
const _hoisted_23 = {
  key: 2,
  class: "divider mt-0 mb-0"
}
const _hoisted_24 = {
  key: 3,
  class: "d-flex align-items-center justify-content-between gap-10 w-100"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "fw-light fs-sm w-50" }, "Business Associate Agreement on file:", -1)
const _hoisted_26 = { class: "d-flex gap-10 align-items-center" }
const _hoisted_27 = {
  key: 0,
  class: "label label_blue pdl-5 pdr-5 pdt-5 pdb-5 h-fit lh-1"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "bullet" }, null, -1)
const _hoisted_29 = {
  key: 1,
  class: "label label_danger pdl-5 pdr-5 pdt-5 pdb-5 h-fit lh-1"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "bullet" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "divider divider_vertical" }, null, -1)
const _hoisted_32 = {
  key: 0,
  width: "16",
  height: "24",
  version: "1.1",
  id: "L9",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 100 100",
  "enable-background": "new 0 0 0 0",
  "xml:space": "preserve"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#8EC986",
  d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
}, [
  /*#__PURE__*/_createElementVNode("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "1s",
    from: "0 50 50",
    to: "360 50 50",
    repeatCount: "indefinite"
  })
], -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "iatse-icon-download fs-lg"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, { error: _ctx.error }, null, 8, ["error"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.type) + " Profile", 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.type) + ":", 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.data?.CompanyName), 1)
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.data?.ContactEmail), 1)
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.data?.ContactName), 1)
        ]),
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("p", _hoisted_18, _toDisplayString(Array.isArray(_ctx.data?.ContactPhone)
                            ? _ctx.data?.ContactPhone.join(' | ')
                            : _ctx.data?.ContactPhone ?? '--'), 1)
        ]),
        (_ctx.type === 'Local')
          ? (_openBlock(), _createElementBlock("div", _hoisted_19))
          : _createCommentVNode("", true),
        (_ctx.type === 'Local')
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.data?.PinExpiration) + " Days", 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.type === 'Local')
          ? (_openBlock(), _createElementBlock("div", _hoisted_23))
          : _createCommentVNode("", true),
        (_ctx.type === 'Local')
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                (_ctx.data?.BusinessAgreementFile)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_27, [
                      _hoisted_28,
                      _createTextVNode(" Yes ")
                    ]))
                  : (_openBlock(), _createElementBlock("small", _hoisted_29, [
                      _hoisted_30,
                      _createTextVNode(" No ")
                    ])),
                _hoisted_31,
                (_ctx.data?.BusinessAgreementFile)
                  ? (_openBlock(), _createElementBlock("small", {
                      key: 2,
                      class: _normalizeClass(['label label_green h-fit pdl-5 pdr-5', { 'disabled': _ctx.loading }]),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (!_ctx.loading && _ctx.downloadFile()))
                    }, [
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_32, _hoisted_34))
                        : (_openBlock(), _createElementBlock("i", _hoisted_35))
                    ], 2))
                  : (_openBlock(), _createElementBlock("small", {
                      key: 3,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('local-upload-baa', 'Upload H&W Business Associate Agreement'))),
                      class: "plan-modal btn btn-primary btn-small fs-sm lh-1 pdl-5 pdr-5"
                    }, " Upload file "))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("small", null, [
        _createTextVNode("This page displays information about your " + _toDisplayString(_ctx.type) + " on file at the Fund Office. ", 1),
        _hoisted_36,
        _createTextVNode("If any of this information needs to be changed or is incorrect, please click "),
        _createElementVNode("a", {
          target: "_blank",
          href: `${_ctx.baseUrl}/en/contact`
        }, "here", 8, _hoisted_37),
        _createTextVNode(" to email the Fund office.")
      ])
    ])
  ], 64))
}